/*
  this file is created in order to use
  theme.breakpoints.up, theme.breakpoints.down, theme.breakpoints.only and theme.breakpoints.between
  functions inside files imported to default-theme.js
*/

import { breakpoints } from '@livable/saas-react-components';
import { createTheme } from '@mui/material/styles';
const breakpointsFunc = createTheme({
  breakpoints
});
export default breakpointsFunc;